import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  InputLabel,
} from "@mui/material";
import { StyledDialog } from "../../../common/components/Dialog";
import { StyledButton } from "../../../common/components/Button";
import { StyledTextField } from "../../../common/components/TextField/styles";
import { yupResolver } from "@hookform/resolvers/yup";
import { serviceProviderSchema } from "../schemas/updateServiceProviderSchema";
import { addServiceProvider } from "../../../api/serviceProviderApi";
import ImageDropzone from "../../settings/components/Services/ImageDropzone";
import { addServiceProviderSchema } from "../schemas/addServiceProviderSchema";

const AddServiceProviderDialog = ({
  openAddServiceProvider,
  handleCloseAddServiceProvider,
  currentServiceProvider,
  fetchServiceProviders,
}) => {
  const {
    register,
    control,
    setValue,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(addServiceProviderSchema),
  });

  useEffect(() => {
    let defaultValues = {};
    defaultValues.serviceId = currentServiceProvider.serviceId;
    reset({ ...defaultValues });
  }, [currentServiceProvider, reset]);

  const submitAddService = async (values) => {
    if (values.imageFile != null) {
      values.imageFile = values.imageFile.file;
    }

    const formData = new FormData();
    for (var key in values) {
      formData.append(key, values[key]);
    }
    await addServiceProvider(formData);
    handleCloseAddServiceProvider();
    fetchServiceProviders();
  };

  const getValue = function (o, s) {
    s = s.replace(/\[(\w+)\]/g, ".$1"); // convert indexes to properties
    s = s.replace(/^\./, ""); // strip a leading dot
    var a = s.split(".");
    for (var i = 0, n = a.length; i < n; ++i) {
      var k = a[i];
      if (k in o) {
        o = o[k];
      } else {
        return;
      }
    }
    return o;
  };

  const handleDrop = (name, file) => {
    setValue(name, file, { shouldValidate: true, shouldTouch: true });
  };

  return (
    <div>
      <StyledDialog
        open={openAddServiceProvider}
        onClose={handleCloseAddServiceProvider}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle> Add Service Provider</DialogTitle>
        <form onSubmit={handleSubmit(submitAddService)}>
          <DialogContent dividers>
            <Grid container direction="row">
              <Grid item xs={10}>
                <StyledTextField
                  variant="outlined"
                  label="Name"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={errors.name}
                  helperText={errors.name?.message}
                  {...register("name")}
                  sx={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={10}>
                <StyledTextField
                  variant="outlined"
                  label="Description"
                  multiline
                  rows={3}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={errors.description}
                  helperText={errors.description?.message}
                  {...register("description")}
                  sx={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={10}>
                <StyledTextField
                  variant="outlined"
                  label="Email"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={errors.email}
                  helperText={errors.description?.email}
                  {...register("email")}
                  sx={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={10}>
                <StyledTextField
                  variant="outlined"
                  type="number"
                  label="Price"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{ inputProps: { step: "any" } }}
                  error={errors.price}
                  helperText={errors.price?.message}
                  {...register("price")}
                  sx={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={10}>
                <InputLabel>Service Provider Image</InputLabel>
              </Grid>
              <ImageDropzone
                type={2}
                label={"Image"}
                name={"imageFile"}
                control={control}
                error={getValue(errors, "imageFile")}
                onDrop={(f) => {
                  handleDrop("imageFile", {
                    file: f,
                    type: 2,
                    subType: 1,
                  });
                }}
              />

              <Grid item xs={10}>
                <StyledTextField
                  variant="outlined"
                  label="Sequence"
                  type="number"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={errors.sequence}
                  helperText={errors.sequence?.message}
                  {...register("sequence")}
                  sx={{ width: "100%" }}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <StyledButton
              theme="purple"
              type="button"
              onClick={handleCloseAddServiceProvider}
            >
              Cancel
            </StyledButton>
            <StyledButton theme="green" type="submit" disabled={isSubmitting}>
              Submit
            </StyledButton>
          </DialogActions>
        </form>
      </StyledDialog>
    </div>
  );
};

export default AddServiceProviderDialog;
